/* eslint-disable no-shadow */

import React, { createContext, useState } from 'react';

export const ContextDownload = createContext();

const Provider = ({ children }) => {
  const [updateCompany, setUpdateCompany] = useState([]);
  const [updateCategory, setUpdateCategory] = useState([]);
  const [updateSegment, setUpdateSegment] = useState([]);
  const [idReport, setIdReport] = useState('')

  const value = {
    updateCompany,
    updateCategory,
    updateSegment,
    idReport,
    setUpdateCompany: (updateCompany) => {
      setUpdateCompany(updateCompany);
    },
    setUpdateCategory: (updateCategory) => {
      setUpdateCategory(updateCategory);
    },
    setUpdateSegment: (updateSegment) => {
      setUpdateSegment(updateSegment)
    },
    setIdReport: (idReport) => {
      setIdReport(idReport)
    }
  };

  return (
    <ContextDownload.Provider value={value}>
      { children }
    </ContextDownload.Provider>
  );
};
export default {
  Provider,
  Consumer: ContextDownload.Consumer,
};
